export default __webpack_public_path__ + "static/media/562.6092d74f.png";